import axios from 'axios';

const api = axios.create({
    baseURL: "https://www.las.app.br/curriculo_api/public/api/"
});

export default api;